<template>
    <div class="row">
        <div class="col-xs-12 col-lg-12 container">
            <div class="col-xs-12 col-lg-12">
                <div class="row container-collapse">
                    <div class="col-xs-12 col-lg-12" @click="show_detail = !show_detail">
                        <div class="container-collapse-header">
                            <span><b>Detalhe</b></span>
                            <span class="collapse-header-arrow" v-if="show_detail"><i class="fa fa-chevron-up"></i></span>
                            <span class="collapse-header-arrow" v-else><i class="fa fa-chevron-down"></i></span>
                        </div>
                    </div>
                    <div v-show="show_detail" class="col-xs-12 col-lg-12 container-collapse-body">
                        <table class="table">
                            <tbody>
                                <tr>
                                    <td>{{ loading ? "Carregando..." : observation }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Api from "@/lib/Api";

export default {
	name: "DeliveryObservation",

	props: {
        current: {
            type: Object,
            require: true,
        },
    },

	data: function() {
		return {
			loading: false,
            show_detail: true,
            //observation: "",
            observation: this.current.observation,
		}
	},

    /*beforeMount: async function() {
        this.loading = true;
        await this.loadObservation();
        this.loading = false;
    },*/

	methods: {
        // Carrega a observação
		loadObservation: async function() {
			let res = null;
			try {
				res = await Api.post("delivery-observation/get-observation", {
                    fk_delivery: this.current.id,
                });
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter a observação.");
                this.loading = false;
				return;
			}
			if (res.error) {
				this.$notification.error(res.data);
				return;
			}
			this.observation = res.data.observation;
		},
	}
}
</script>

<style scoped>
    .container {
        margin-top: 15px;
    }

    .container-collapse {
        margin-bottom: 15px;
        border: 1px solid #ddd;
        border-radius: 5px;
        padding: 15px;
    }

    .container-collapse-header {
        cursor: pointer;
    }

    span.collapse-header-arrow {
        float: right;
    }

    table { 
        margin-top: 15px;
        width: 100%;
        border-collapse: collapse;
    }

    thead > tr > th {
        text-align: center;
    }

    tr:nth-of-type(odd) { 
        background: #eee; 
    }

    th { 
        background: #ccc;
        font-weight: bold; 
    }

    td, th { 
        padding: 10px; 
        border: 1px solid #ccc; 
        text-align: left; 
        font-size: 14px;
    }
</style>